// 8 philosophers — vectors, titles, descriptions, quotes verbatim.
export const PHILOSOPHERS = [
  {
    id: "aurelius",
    name: "Marcus Aurelius",
    title: "The Philosopher Emperor",
    vector: { DIS: 92, CUR: 60, RES: 82, EMP: 68, AMB: 50, SER: 95 },
    description:
      "You rule yourself before anything else. Calm under fire, disciplined without an audience — you'd rather master a bad day than complain about it.",
    quote: "You have power over your mind — not outside events.",
  },
  {
    id: "nietzsche",
    name: "Friedrich Nietzsche",
    title: "The Hammer",
    vector: { DIS: 55, CUR: 82, RES: 90, EMP: 25, AMB: 97, SER: 18 },
    description:
      "You don't want comfort — you want intensity. What doesn't kill you becomes raw material. Most people negotiate with life; you make demands.",
    quote: "He who has a why to live can bear almost any how.",
  },
  {
    id: "socrates",
    name: "Socrates",
    title: "The Gadfly",
    vector: { DIS: 50, CUR: 98, RES: 70, EMP: 62, AMB: 30, SER: 72 },
    description:
      "You'd rather be right about being wrong than wrong about being right. Questions are your native language, and no assumption is safe around you.",
    quote: "The unexamined life is not worth living.",
  },
  {
    id: "epicurus",
    name: "Epicurus",
    title: "The Garden Keeper",
    vector: { DIS: 45, CUR: 65, RES: 42, EMP: 80, AMB: 15, SER: 92 },
    description:
      "You've solved the puzzle most people die trying to solve: enough is enough. Good friends, simple pleasures, zero drama — that's not settling, that's winning.",
    quote: "Not what we have but what we enjoy constitutes our abundance.",
  },
  {
    id: "beauvoir",
    name: "Simone de Beauvoir",
    title: "The Free Spirit",
    vector: { DIS: 60, CUR: 88, RES: 70, EMP: 78, AMB: 92, SER: 20 },
    description:
      "You refuse every script written for you. Freedom is a daily practice, and you extend it to others as fiercely as you claim it for yourself.",
    quote: "One is not born, but rather becomes, oneself.",
  },
  {
    id: "diogenes",
    name: "Diogenes",
    title: "The Untamed",
    vector: { DIS: 25, CUR: 68, RES: 95, EMP: 30, AMB: 10, SER: 85 },
    description:
      "You need almost nothing, fear almost nothing, and respect exactly no one's pretensions. Society's opinion of you is its problem, not yours.",
    quote: "Stand out of my sunlight.",
  },
  {
    id: "confucius",
    name: "Confucius",
    title: "The Harmonizer",
    vector: { DIS: 95, CUR: 62, RES: 60, EMP: 90, AMB: 48, SER: 75 },
    description:
      "You build order the slow way: daily practice, kept promises, respect that's earned. People trust you because you show up — every single time.",
    quote: "It does not matter how slowly you go as long as you do not stop.",
  },
  {
    id: "arendt",
    name: "Hannah Arendt",
    title: "The Clear-Eyed",
    vector: { DIS: 55, CUR: 95, RES: 88, EMP: 60, AMB: 55, SER: 30 },
    description:
      "You think for yourself in rooms where everyone else has stopped. Courage, to you, is mostly intellectual — refusing easy answers when the stakes are real.",
    quote: "The sad truth is that most evil is done by people who never make up their minds.",
  },
];

export const TRAITS = ["DIS", "CUR", "RES", "EMP", "AMB", "SER"];

export const TRAIT_LABELS = {
  DIS: "Discipline",
  CUR: "Curiosity",
  RES: "Resilience",
  EMP: "Empathy",
  AMB: "Ambition",
  SER: "Serenity",
};

export const MAX_RAW = {
  DIS: 28,
  CUR: 40,
  RES: 29,
  EMP: 41,
  AMB: 38,
  SER: 36,
};

export const BASELINE = {
  DIS: 55.06,
  CUR: 43.75,
  RES: 51.72,
  EMP: 42.68,
  AMB: 41.67,
  SER: 59.03,
};
